import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelL } from 'atoms/typography';

import firstPlace from './assets/firstPlace.png';
import secondPlace from './assets/secondPlace.png';
import thirdPlace from './assets/thirdPlace.png';

const Root = styled(Horizontal).attrs({ center: true })`
  position: relative;
  width: var(--quadruple-unit);
  height: var(--quadruple-unit);
  isolation: isolate;
`;
const AbsoluteImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  object-fit: contain;
  filter: drop-shadow(0 5px 3px var(--c-neutral-100));
`;

type Props = { rank: number };
export const PodiumIcon = ({ rank }: Props) => {
  let src = firstPlace;

  if (rank === 2) {
    src = secondPlace;
  }
  if (rank === 3) {
    src = thirdPlace;
  }

  const onPodium = rank <= 3;

  return (
    <Root>
      {onPodium && <AbsoluteImg src={src} />}
      <LabelL bold as="span">
        <FormattedNumber value={rank} />
      </LabelL>
    </Root>
  );
};
